import React, { useEffect } from 'react';
import { Redirect } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { ClientMethods } from '../../../../services/auth';
import CmtCard from '../../../../@coremat/CmtCard';
import { CurrentClientMethod } from '../../../../@jumbo/constants/AppConstants';
import { Box } from '@material-ui/core';
import CmtAvatar from '../../../../@coremat/CmtAvatar';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Typography from '@material-ui/core/Typography';
// import { modernWidget } from '../../../../@fake-db/widgets/modern';
import { NavLink } from 'react-router-dom';
import { ClientViewDataMethods } from '../../../../services/auth';
import { CurrentClientViewMethod } from '../../../../@jumbo/constants/AppConstants';

const useStyles = makeStyles(() => ({
  cardRoot: {
    height: '100%',
    minHeight: 90,
  },
  navLink: {
    padding: '10px',
    display: 'flex',
    alignItems: 'center',
    color: '#fff',
    width: '100%',
    borderBottom: '1px solid rgb(46 46 46)',
  },
  userBoxRoot: {
    width: 50,
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    overflow: 'hidden',

    '& > div': {
      boxShadow: '0 6px 4px 2px rgba(0,0,0,.2)',
    },
  },
}));

const UserSummery = ({ method = CurrentClientMethod, method1 = CurrentClientViewMethod }) => {
  const classes = useStyles();
  const location = useLocation();
  const dispatch = useDispatch();
  const ClientData = useSelector(state => state.auth.getclientList);

  console.log('ClientData..side...', ClientData);

  useEffect(() => {
    const token = localStorage.getItem('token');
    dispatch(ClientMethods[method].onClientList(token));
  }, []);

  const onSideNavInfoClick = item => {
    // console.log('onSideNavInfoClick...item', item);
    dispatch(ClientViewDataMethods[method1].onClientViewData(item));
  };

  return (
    <CmtCard className={classes.cardRoot}>
      {ClientData &&
        ClientData.length > 0 &&
        ClientData.map(elm => (
          <Box display="flex" alignItems="center" height={1}>
            <NavLink className={classes.navLink} to={'/clients/' + elm._id + '/isView'}>
              {/* <Box className={classes.userBoxRoot}>
                <CmtAvatar size={75} src={userSummary.profile_pic} />
                <CmtAvatar size={75} src={'profile_pic'} />
              </Box> */}
              <Box onClick={() => onSideNavInfoClick(elm._id)}>
                <Typography component="div" variant="h4">
                  {elm.name}
                </Typography>
              </Box>
            </NavLink>
          </Box>
        ))}
    </CmtCard>
  );
};

export default UserSummery;
